// Miscellaneous helpers that don't fit cleanly into a domain bucket.
// If this file grows past ~6-8 entries it's a sign one of these deserves
// its own focused module.

import { features_mapping } from '../models/constants';

export function isObjectEmpty(obj: any): boolean {
  return Object.keys(obj).length === 0;
}

export function notBelowZero(input_entry: number): number {
  if (input_entry <= 0) {
    input_entry = 0;
    return 0;
  } else {
    return input_entry;
  }
}

export function removeBlankSalesRows<T extends Record<string, any>>(
  rows: T[],
): T[] {
  return rows.filter((row) =>
    Object.values(row).some(
      (value) =>
        value !== null && !(Array.isArray(value) && value.length === 0),
    ),
  );
}

export function removeBlankExpenseRows<T extends Record<string, any>>(
  rows: T[],
): T[] {
  return rows.filter((row) =>
    Object.values(row).some(
      (value) =>
        value !== null && !(Array.isArray(value) && value.length === 0),
    ),
  );
}

export function getFeatureVisibility(
  group: string,
  name: string,
): boolean | null {
  const g = String(group ?? '')
    .trim()
    .toLowerCase();
  const n = String(name ?? '')
    .trim()
    .toLowerCase();
  const found = features_mapping.find((entry: any) => {
    return (
      String(entry.group ?? '')
        .trim()
        .toLowerCase() === g &&
      String(entry.name ?? '')
        .trim()
        .toLowerCase() === n
    );
  });
  return found ? Boolean((found as any).visible) : null;
}

export function findUserDigitalSignature(
  sharedService: any,
  user_id: string,
): string | null {
  const digital_signature = sharedService.company_info.users.find(
    (user) => user.user_id === user_id,
  )?.signature;
  if (!!digital_signature) {
    return digital_signature;
  } else {
    return null;
  }
}
